// Configurações de ambiente
export const config = {
 api: {
 baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api',
 timeout: 10000,
 },
 app: {
 name: 'ambcar',
 version: '1.0.0',
 description: 'Sistema de gestão para concessionárias de automóveis',
 },
 features: {
 darkMode: true,
 multiLanguage: true,
 notifications: true,
 analytics: true,
 },
 plans: {
 free: {
 maxVehicles: 50,
 maxLeads: 100,
 maxSellers: 5,
 },
 premium: {
 maxVehicles: 1000,
 maxLeads: 10000,
 maxSellers: 50,
 },
 },
} as const
